<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.family"
            />
            <bita-input
              type="text"
              name="phone"
              label="شماره همراه"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.phone"
              @change="findDriver(form.phone, 0)"
            />
            <bita-input
              type="text"
              name="nationalCode"
              label="کد ملی"
              rules="required|irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.national_code"
              @change="findDriver(0, form.national_code)"
            />
            <bita-input
              type="text"
              name="priority"
              label="اولویت"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.priority"
            />
          </div>
          <bita-bootbutton
            class="mr-2"
            type="primary"
            title="ثبت"
            icon="fas fa-check"
            btn-width="150px"
            :isLoading="isLoading"
            @click.native="handleSubmit"
          />
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      form: {
        phone: "",
        national_code: "",
        priority: "",
      },
    };
  },
  methods: {
    findDriver(phone, national_code) {
      if (this.$ssnIsValid(national_code) || phone.length == 11) {
        this.$persistClient(
          "get",
          `drivers/find?phone=${phone}&national_code=${national_code}`
        ).then((res) => {
          let response = res.data.data;
          if (response) {
            this.form = {
              name: response.name,
              family: response.family,
              phone: response.phone,
              national_code: response.national_code,
            };
          } else {
            this.reset();
          }
        });
      }
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    reset() {
      this.form = {
        name: "",
        family: "",
        phone: "",
        national_code: "",
        priority: "",
      };
      this.$refs.form.reset();
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
